"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorFilter = void 0;
var browser_1 = require("@cian/config/browser");
var ErrorFilter = /** @class */ (function () {
    function ErrorFilter() {
        this.filters = getFilters();
    }
    ErrorFilter.prototype.approve = function (error) {
        var message;
        var stack;
        if (typeof error === 'string') {
            message = error;
        }
        else {
            message = error.message;
            stack = error.stack;
        }
        return !this.filters.some(function (filter) {
            return (message && filter.test(message)) || (stack && filter.test(stack));
        });
    };
    return ErrorFilter;
}());
exports.ErrorFilter = ErrorFilter;
function getFilters() {
    var filterStrings = browser_1.getConfig().get('logger.browser.errorFilter');
    return (filterStrings || []).map(function (filterString) { return new RegExp(filterString); });
}
//# sourceMappingURL=errorFilter.js.map